import { AnimatePresence } from 'framer-motion';
import React, { Fragment, useState } from 'react';
import GenieMemory from './GenieMemory';
import { settingsIcon } from '../../components/common/Icons';
import { ItemId } from './GenieConfiguration';
import { MEDICINES, LAB_INVESTIGATIONS } from './GenieConfiguration';

interface GenieMemorySidebarProps {
    itemId: ItemId;
}

export enum SELECTED_TAB {
    MED = 'medications',
    INJ = 'injection',
    LAB = 'lab_investigations',
    CUS = 'custom_section',
}

const getToShowTabs = (itemId: ItemId):SELECTED_TAB[] => {
    if (itemId === LAB_INVESTIGATIONS) return [SELECTED_TAB.LAB];
    else if (itemId === MEDICINES) return [SELECTED_TAB.MED, SELECTED_TAB.INJ];
    else return [SELECTED_TAB.CUS];
};

const GenieMemorySidebar:React.FC<GenieMemorySidebarProps> = ({itemId = MEDICINES}) => {
    const [open, setOpen] = useState<boolean>(false);
    const toShow = getToShowTabs(itemId);
    return (
        <Fragment>
            <AnimatePresence>
                {open && (
                    <GenieMemory itemId={itemId} onClose={() => setOpen(false)} toShow={toShow} />
                )}
            </AnimatePresence>
            <button
                className="flex items-center space-x-8 mr-16 mb-20 px-16 py-8 text-white bg-darwin-primary-500 font-700 rounded-4"
                onClick={() => setOpen((prev) => !prev)}
            >
                {settingsIcon('fill-white')}

                <span>Memory Settings</span>
            </button>
        </Fragment>
    );
};

export default GenieMemorySidebar;
